import { cn } from "@/modules/lib/utils"
import { LoaderCircle } from "lucide-react"

export function LoadingSpinner({
  color,
  size = 24,
  className,
  ...props
}: { color?: string; size?: number; className?: string } & React.ComponentProps<"div">) {
  return (
    <div className={cn("flex h-full w-full items-center justify-center", className)} {...props}>
      <LoaderCircle className="animate-spin" color={color ?? "currentColor"} size={size} />
    </div>
  )
}
